import { Search } from 'lucide-react';
import { TypingLoader } from '../../../../components/chat-gpt/typing-loader';
import { ShowMessagesAndFiles } from '../../../assistant/ShowMessagesAndFields';
import { TopBar } from '../topBar';
import { Chip } from '../../../../components/general/chip';
import { TextMessageBox } from '../../../../components/chat-gpt/TextMessageBox';
import { QuickOptionsPanel } from '../optionsPanel';
import { ClientFormModal } from '../../form';
import { Dialog } from '../../../../components/general/dialog/dialog';
import { ConnectButton } from '../../../../components/chat-gpt/sharepoint/ConnectButton';
import { FileExplorer } from '../../../../components/chat-gpt/sharepoint/FileExplorer';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FolderIcon from '@mui/icons-material/Folder';
import { useTenderChatHook } from './hook';
import { Autocomplete, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export const ChatMockupLicitaciones = () => {
    const {
        handleModifyCalender,
        calendarFields,
        isOpenCalendarModal,
        setIsOpenCalendarModal,
        fechas,
        setFechas,
        quickOpen,
        setQuickOpen,
        scrollRef,
        messages,
        onClickDownload,
        isLoading,
        keyOptions,
        sendMessage,
        selectedIndex,
        openOptionButton,
        setOpenOptionButton,
        setSelectedIndex,
        sharepointItems,
        setSharepointItems,
        files,
        presets,
        isOpenModal,
        setIsOpenModal,
        threadId,
        isOpenModalFiles,
        setIsOpenModalFiles,
        isSharepointAuth,
        setIsSharepointAuth,
        VisuallyHiddenInput,
        setSharepointModalOpen,
        acceptedFiles,
        handleFileInputChange,
        openSharepointSelector,
        sharepointModalOpen,
        idTender,
        isOnlyView,
        setIsOnlyView,
        isOpenUsersModal,
        setIsOpenUsersModal,
        selectedUsers,
        setSelectedUsers,
        users,
        handleAssignUsers,
    } = useTenderChatHook();

    return (
        <div className="tender-chat">
            <div className="tender-chat__container">
                <TopBar
                    setIsOpenModal={setIsOpenModal}
                    onToggleQuick={() => setQuickOpen((v) => !v)}
                    quickOpen={quickOpen}
                    setIsOnlyView={setIsOnlyView}
                />

                <div ref={scrollRef} className="tender-chat__messages">
                    <ShowMessagesAndFiles
                        messages={messages}
                        onClickDownload={onClickDownload}
                    />

                    {isLoading && (
                        <div className="tender-chat__typing">
                            <TypingLoader />
                        </div>
                    )}
                </div>

                <div className="tender-chat__quick-actions">
                    {keyOptions.map((s, i) => (
                        <Chip key={i} onClick={() => sendMessage(s)}>
                            <Search />
                            {s}
                        </Chip>
                    ))}
                </div>

                <TextMessageBox
                    onSendMessage={sendMessage}
                    placeholder="Escribe tu mensaje sobre una licitación..."
                    isAdvancedMode
                    anchorRef={scrollRef}
                    options={[]}
                    selectedIndex={selectedIndex}
                    openOptionButton={openOptionButton}
                    handleClose={(event) => {
                        if (
                            scrollRef.current &&
                            scrollRef.current.contains(
                                event.target as HTMLElement
                            )
                        )
                            return;
                        setOpenOptionButton(false);
                    }}
                    handleMenuItemClick={setSelectedIndex}
                    handleToggle={() => setOpenOptionButton((v) => !v)}
                    isVisibleButtons={false}
                    adittionalShareponitItems={sharepointItems}
                    adittionalLocalItems={files}
                    disable={isLoading}
                />
            </div>

            <QuickOptionsPanel
                open={quickOpen}
                onClose={() => setQuickOpen(false)}
                onSend={(t: string) => {
                    if (t === '__ADD_USERS__') {
                        setIsOpenUsersModal(true);
                        setQuickOpen(false);
                        return;
                    }
                    if (t == '__MODIFY_CALENDAR__') {
                        setIsOpenCalendarModal(true);
                        setQuickOpen(false);
                        return;
                    }
                    sendMessage(t);
                    setQuickOpen(false);
                }}
                presets={presets || {}}
            />
            <ClientFormModal
                isOpen={isOpenModal}
                onClose={() => setIsOpenModal(false)}
                setIsOpen={setIsOpenModal}
                threadId={threadId}
                idTender={idTender}
                isOnlyView={isOnlyView}
            />

            <Dialog
                title="Analizar pliego"
                open={isOpenModalFiles}
                onClose={() => setIsOpenModalFiles(false)}
            >
                <label className="tender-chat__file-upload">
                    <AttachFileIcon />
                    Adjuntar archivos
                    <VisuallyHiddenInput
                        type="file"
                        multiple
                        accept={acceptedFiles}
                        onChange={handleFileInputChange}
                    />
                </label>

                {!isSharepointAuth && (
                    <ConnectButton
                        setIsSharepointAuth={setIsSharepointAuth}
                        setSharepointModalOpen={setSharepointModalOpen}
                    />
                )}

                {isSharepointAuth && (
                    <button
                        onClick={openSharepointSelector}
                        className="tender-chat__sharepoint-btn"
                    >
                        <FolderIcon />
                        Seleccionar archivos o carpetas desde SharePoint
                    </button>
                )}
            </Dialog>
            <Dialog
                title="Agregar usuarios a esta Licitacion"
                open={isOpenUsersModal}
                onClose={() => setIsOpenUsersModal(false)}
                textSecondBtn="Guardar"
                onClickSecondBtn={handleAssignUsers}
            >
                <div style={{ padding: '1rem' }}>
                    <Autocomplete
                        multiple
                        options={users || []}
                        value={selectedUsers || []}
                        onChange={(event, newValue) =>
                            setSelectedUsers(newValue)
                        }
                        getOptionLabel={(option) =>
                            `${option.name} ${option.surname}`
                        }
                        isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                        }
                        filterSelectedOptions
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Agregar usuarios"
                                placeholder="Selecciona usuarios"
                            />
                        )}
                    />
                </div>
            </Dialog>

            <Dialog
                title="Administrar Calendario de Notificaciones"
                open={isOpenCalendarModal}
                onClose={() => setIsOpenCalendarModal(false)}
                textSecondBtn="Guardar"
                onClickSecondBtn={handleModifyCalender}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div
                        style={{
                            padding: '1rem',
                            display: 'grid',
                            gap: '1rem',
                        }}
                    >
                        {calendarFields.map((field) => (
                            <DatePicker
                                key={field.key}
                                label={field.label}
                                value={fechas[field.key]}
                                onChange={(value) =>
                                    setFechas((prev) => ({
                                        ...prev,
                                        [field.key]: value,
                                    }))
                                }
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        fullWidth: true,
                                    },
                                }}
                            />
                        ))}
                    </div>
                </LocalizationProvider>
            </Dialog>

            <FileExplorer
                open={sharepointModalOpen}
                onClose={() => setSharepointModalOpen(false)}
                selectedItems={sharepointItems}
                setIsSharepointAuth={setIsSharepointAuth}
                setSharepointItems={setSharepointItems}
                setSharepointModalOpen={setSharepointModalOpen}
            />
        </div>
    );
};
